var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Time Ranges","storeName":"Time_range","labelAddNew":"Agregar nuevo Time Range","canAdd":true,"canEdit":true,"canDelete":true,"canSearch":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }